
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"100","width":"100","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M63.9 32.3H36.1c-2.1 0-3.7 1.7-3.7 3.7v27.9c0 2.1 1.7 3.7 3.7 3.7H64c2.1 0 3.7-1.7 3.7-3.7V36.1c0-2.1-1.7-3.8-3.8-3.8zm-3.7 27.9H39.8V39.8h20.4v20.4z"}}),_c('path',{attrs:{"d":"M93.8 53.7c2.1 0 3.7-1.7 3.7-3.7s-1.7-3.7-3.7-3.7h-7.7V35.4h7.7c2.1 0 3.7-1.7 3.7-3.7S95.8 28 93.8 28h-7.7v-1.1c0-7.1-5.8-12.9-12.9-12.9h-1.1V6.2c0-2.1-1.7-3.7-3.7-3.7-2.1 0-3.7 1.7-3.7 3.7v7.7h-11V6.2c0-2.1-1.7-3.7-3.7-3.7s-3.7 1.7-3.7 3.7v7.7H35.4V6.2c0-2.1-1.7-3.7-3.7-3.7S28 4.2 28 6.2v7.7h-1.1c-7.1 0-12.9 5.8-12.9 12.9v1.1H6.2c-2.1 0-3.7 1.7-3.7 3.7s1.7 3.7 3.7 3.7h7.7v10.9H6.2c-2.1 0-3.7 1.7-3.7 3.7s1.7 3.7 3.7 3.7h7.7v10.9H6.2c-2.1 0-3.7 1.7-3.7 3.7s1.7 3.7 3.7 3.7h7.7V73c0 7.1 5.8 12.9 12.9 12.9h1.1v7.7c0 2.1 1.7 3.7 3.7 3.7s3.7-1.7 3.7-3.7v-7.7h10.9v7.7c0 2.1 1.7 3.7 3.7 3.7s3.7-1.7 3.7-3.7v-7.7h10.9v7.7c0 2.1 1.7 3.7 3.7 3.7 2.1 0 3.7-1.7 3.7-3.7v-7.7H73c7.1 0 12.9-5.8 12.9-12.9v-1.1h7.7c2.1 0 3.7-1.7 3.7-3.7s-1.7-3.7-3.7-3.7h-7.7V53.7h7.9zM78.6 73.2c0 3-2.4 5.4-5.4 5.4H26.8c-3 0-5.4-2.4-5.4-5.4V26.8c0-3 2.4-5.4 5.4-5.4h46.4c3 0 5.4 2.4 5.4 5.4v46.4z"}})])
          )
        }
      }
    